export function buildMentorObjectsWithTheirAssociatedChambers({ mentorList, chamberList }) {
  return mentorList?.map((mentor) => {
    const associatedChambers = findAssociatedChambersForMentor(mentor?.id, chamberList)
    return {
      ...mentor,
      associatedChambers: associatedChambers,
    }
  })
}

function findAssociatedChambersForMentor(mentorId, chamberList) {
  return chamberList?.filter((chamber) => {
    const isMentorAssociated = !!chamber?.mentorsAndAuditors?.find(
      (mentorWithAuditor) => mentorWithAuditor?.mentorId === mentorId,
    )

    return isMentorAssociated
  })
}
